import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  selected: {
    backgroundColor: colors.primary600,
    color: colors.white,
  },
})

export interface AddonProductVariationsProps<Value extends string | number, Data> {
  title?: string
  options?: {
    label: string
    value: Value
    data?: Data
    disabled?: boolean
  }[]
  value?: Value
  onSelect?: (value: Value) => void
}

export const AddonProductVariations = <Value extends string | number, Data = unknown>(props: AddonProductVariationsProps<Value, Data>) => {
  const { title, options, value, onSelect } = props

  const handleSelect = (value: Value) => () => {
    onSelect?.(value)
  }

  return (
    <VStack gap={2}>
      <Text color={colors.grey800}>{title}</Text>
      <HStack gap={2}>
        {options?.map(option => (
          <Button
            key={option.value}
            rootStyle={value === option.value && styles.selected}
            variant="outlined"
            onClick={handleSelect(option.value)}
            disabled={option.disabled}
          >
            {option.label}
          </Button>
        ),
        )}
      </HStack>
    </VStack>
  )
}
